package dev.mft.website

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.adaptive.currentWindowAdaptiveInfo
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalUriHandler
import androidx.window.core.layout.WindowSizeClass
import dev.mft.website.composable.footer.Footer
import dev.mft.website.composable.header.Header

@Composable
fun App() {
    val uriHandler = LocalUriHandler.current

    MaterialTheme {
        Column(
            modifier = Modifier
                .fillMaxSize()
        ) {

            val windowSizeClass: WindowSizeClass = currentWindowAdaptiveInfo().windowSizeClass

            val modifierRow = Modifier
                .fillMaxWidth()
                .weight(1f)

            Header(
                modifierMainRow = modifierRow,
                windowSizeClass = windowSizeClass
            )

            Footer(
                modifierMainRow = modifierRow,
                uriHandler = uriHandler,
                windowSizeClass = windowSizeClass
            )
        }
    }
}
